// АНИМ.1: Zustand store для текущей фазы перехода.
//
// Используется и хуком useScreenTransition (пишет), и компонентом
// TransitionOverlay (читает + рисует middle-кадр / pixel-sort bars).
// Отдельный store, не часть useGameStore — переходы изолированы от
// бизнес-логики и не должны её перерендеривать.

import { create } from 'zustand';
import type { TransitionPhase, TransitionVariant } from './types';

interface TransitionState {
  phase: TransitionPhase;
  variant: TransitionVariant;
  set: (phase: TransitionPhase, variant?: TransitionVariant) => void;
}

export const useTransitionStore = create<TransitionState>((set) => ({
  phase: 'idle',
  variant: 'glitch',
  set: (phase, variant) => set((s) => ({ phase, variant: variant ?? s.variant }))
}));
